var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inDevelopment)?_c('div',[_c('div',{staticClass:"create-order-icon-sp",on:{"click":function($event){_vm.showMenu = true}}},[_c('img',{staticClass:"img",attrs:{"src":"spa_static_mobile/icon/order-but120_120@3x.png"}})]),_c('actionsheet',{attrs:{"menus":_vm.box.items.map(function (v) {
        v.label = v.text
        v.value = v.id
        return v
      }),"show-cancel":""},on:{"on-click-menu":_vm.menuClick},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }